<template>
  <div class="social_media_v2">
    <a href="mailto:svidovskiy2019@mail.ru"><div class="mail_social"></div></a>
    <a href="https://t.me/sevenstar116"><div class="tg_social"></div></a>
    <a href="https://wa.me/79258001637"><div class="wp_social"></div></a>
  </div>
</template>
